// GENERATED by tools/manual/capture.mjs — do not edit by hand.
// Re-run the capture to change anything here; hand edits are overwritten.
//
// Figures are shot against ONE operator's account, because the console
// renders one client's vessels, limits and branding. These were captured
// against https://seastateops.com.

export interface Callout {
  n: number;
  note: string;
}

export interface Figure {
  id: string;
  file: string;
  route: string;
  title: string;
  caption: string;
  alt: string;
  callouts: Callout[];
}

export const FIGURES: Record<string, Figure> = {
  "console-overview": {
    "id": "console-overview",
    "file": "assets/manual/console-overview.png",
    "route": "/console",
    "title": "The console at a glance",
    "caption": "The console opens on the map with the workspace panels alongside. Everything else in this manual is reached from here.",
    "alt": "The console at a glance",
    "callouts": [
      {
        "n": 1,
        "note": "The map. Colour is the wind or wave field for the moment shown on the timeline. Click anywhere on the water to read that point."
      },
      {
        "n": 2,
        "note": "The workspace rail. Each button swaps the panel beside it — Site, SVP, Fleet, Observations, Tropical, Systems. Number keys 1–9 do the same. Clicking the workspace you are already in closes the panel for more map."
      },
      {
        "n": 3,
        "note": "Console, Vessels, Guide and Methods. Vessels is where limits are set."
      }
    ]
  },
  "systems-health": {
    "id": "systems-health",
    "file": "assets/manual/systems-health.png",
    "route": "/console",
    "title": "Checking the data sources",
    "caption": "Systems is the honesty panel: every upstream feed with its live status. When something looks wrong or empty, this is the first place to look.",
    "alt": "Checking the data sources",
    "callouts": [
      {
        "n": 1,
        "note": "Each row is one feed. A panel that has gone quiet is either a source that is down or a genuine absence of data — this tells you which, so you never mistake one for the other."
      }
    ]
  },
  "where-to-work": {
    "id": "where-to-work",
    "file": "assets/manual/where-to-work.png",
    "route": "/console",
    "title": "Comparing areas",
    "caption": "When the position is still movable, Areas asks the workability question across candidate areas rather than at a single point.",
    "alt": "Comparing areas",
    "callouts": [
      {
        "n": 1,
        "note": "The same vessel-and-operation judgement, applied to each area, so the comparison is like for like."
      }
    ]
  },
  "reading-a-point": {
    "id": "reading-a-point",
    "file": "assets/manual/reading-a-point.png",
    "route": "/console",
    "title": "Reading a point",
    "caption": "Clicking the water pulls a full forecast for that exact position — models side by side, never blended into one line.",
    "alt": "Reading a point",
    "callouts": [
      {
        "n": 1,
        "note": "Location primer — what is around that point: blocks and leases, the nearest port, whale rules, and how this month usually behaves there."
      },
      {
        "n": 2,
        "note": "Window briefing — the plain-language read of the next few days for the vessel and operation you have selected."
      }
    ]
  },
  "workability": {
    "id": "workability",
    "file": "assets/manual/workability.png",
    "route": "/console",
    "title": "The workability read",
    "caption": "Workability answers one question: can this boat do this job here, now and over the next week — and how confident is that answer.",
    "alt": "The workability read",
    "callouts": [
      {
        "n": 1,
        "note": "Green, amber or red against your own limits for the selected vessel and operation. Amber is the one to read carefully: it means the models disagree enough that the call could go either way."
      }
    ]
  },
  "setting-limits": {
    "id": "setting-limits",
    "file": "assets/manual/setting-limits.png",
    "route": "/vessels",
    "title": "Setting your limits",
    "caption": "Every workability colour is measured against numbers you set here. Until a vessel and operation have a limit of their own, the console falls back to an industry default — safe, but not yours.",
    "alt": "Setting your limits",
    "callouts": []
  },
  "svp": {
    "id": "svp",
    "file": "assets/manual/svp.png",
    "route": "/console",
    "title": "Sound-velocity profiles",
    "caption": "The SVP panel draws the modelled sound-velocity curve for the clicked point, with a real Argo float cast beside it when one is close enough.",
    "alt": "Sound-velocity profiles",
    "callouts": [
      {
        "n": 1,
        "note": "Modelled profile with depth. An observed Argo cast, when one is nearby, is drawn beside it as a separate line — never averaged into it — and labelled with the float, its age and its distance."
      }
    ]
  },
  "bridge-display": {
    "id": "bridge-display",
    "file": "assets/manual/bridge-display.png",
    "route": "/console",
    "title": "Bridge display",
    "caption": "Dusk and Night re-cast the whole console for a darkened bridge. The safety colours are the one thing that never changes.",
    "alt": "Bridge display",
    "callouts": [
      {
        "n": 1,
        "note": "The theme control sits beside the coordinate readout. Auto follows the sun at the point you are looking at, not your computer's clock."
      }
    ]
  }
};
